import { render, staticRenderFns } from "./MaterialFirstFMDEditor.vue?vue&type=template&id=6d2b6c9d&scoped=true&"
import script from "./MaterialFirstFMDEditor.vue?vue&type=script&lang=js&"
export * from "./MaterialFirstFMDEditor.vue?vue&type=script&lang=js&"
import style0 from "./MaterialFirstFMDEditor.vue?vue&type=style&index=0&id=6d2b6c9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b6c9d",
  null
  
)

export default component.exports